export enum SimplifiedRolesIdsEnum {
    Comprador = 1,
    DonoDaOficina = 2,
    Vendedor = 4,
    GestorDePecas = 16,
    Central = 32
}
